import React from "react";
import { Layout } from "antd";
import '../App.css'
import NavBar from "../components/Header";
import SlideContent from "../components/SlideContent";
import KakiKaki from "../components/Footer";
import CardContent from "../components/CardContent";

const { Header, Footer, Content } = Layout;

function ProfilePage() {
  return (
    <Layout>
      <Header><NavBar/></Header>
      <Content></Content>
      <Content></Content>
      <Footer style={{background:"#7F7CAF"}}>
          <KakiKaki/></Footer>
    </Layout>
  );
}

export default ProfilePage;